import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const IDLE_TIMEOUT = 1000 * 60 * 20; // 20 minutes

@Injectable({
  providedIn: 'root',
})
export class UserIdleService {
  lastEventAt: number = 0;
  interval: any;
  idle$ = new BehaviorSubject(false);

  constructor() {}

  bind() {
    this.lastEventAt = Date.now();
    const OPTIONS = { capture: true, passive: true };
    const EVENTS: (keyof WindowEventMap)[] = ['click', 'keydown', 'mousemove', 'mousedown', 'touchmove', 'scroll'];
    EVENTS.forEach((event) => window.addEventListener(event, () => this.resetTimer(), OPTIONS));
    this.interval = setInterval(() => this.checkTimer(), 5000);
  }

  stop() {
    clearInterval(this.interval);
  }

  private resetTimer() {
    this.lastEventAt = Date.now();
    if (this.idle$.value) {
      this.idle$.next(false);
    }
  }

  private checkTimer() {
    const timeSinceLast = Date.now() - this.lastEventAt;
    if (timeSinceLast > IDLE_TIMEOUT && !this.idle$.value) {
      this.idle$.next(true);
    }
  }
}
